import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RouteDetails from '../components/routes/RouteDetails';
import RouteRating from '../components/routes/RouteRating';

const ViewRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/routes')}
            className="text-blue-600 hover:text-blue-800 mb-4 flex items-center"
          >
            ← Back to Routes
          </button>

          <RouteDetails routeId={id} />

          {/* Route Ratings and Reviews could go here in the future */}

          <RouteRating routeId={id ? parseInt(id) : undefined} />

        </div>
      </div>
    </div>
  );
};

export default ViewRoute;